module.exports = __webpack_public_path__ + "media/images/landing/icon-flexible-benefits-device-d3bd8233a58796294f5922dd0b587882.svg";